// extracted by mini-css-extract-plugin
export default {"solanaFMIcon":"SolanaLinks-module__solanaFMIcon--bwUxh","tensorLink":"SolanaLinks-module__tensorLink--wz47E","dexscreenerLink":"SolanaLinks-module__dexscreenerLink--ZnWec"};